import React, { Component } from "react";
import { SearchResult } from "./SearchResult.component";

import $ from "jquery";
import { PersonCasesResult } from "./PersonCases.component";
import { SearchSelect } from "./SearchSelect.component";
import interpolate from "../utils/interpolate";
import { SearchIssues } from "../dataStore/atlassian-services";
import Spinner from "@atlaskit/spinner";

class SearchField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedData: "",
      userData: "",
      readData: "",
      existingOptions: "",
      fieldConfig: props.fieldConfig,
      dataSource: props.dataSource,
      fields: props.fieldConfig?.issueFields,
      issueInfoSheet: props.fieldConfig?.issueInfoSheet,
      jql: props.fieldConfig?.jql,
      actorAccountId: props.actorAccountId,
      requestType: props.requestType,
      issueFieldsArray: props.issueFieldsArray,
      token: props.token,
    };
  }

  componentDidMount() {
    window.AP.request("/rest/api/3/myself")
      .then((data) => {
        let json = JSON.parse(data.body);
        this.setState({ userData: json.displayName });
      })
      .catch((e) => console.log(e.err));

    const fieldName = this.state.fieldConfig.name;
    const isRequired = this.state.fieldConfig.isRequired;
    const targetField = this.state.fieldConfig.targetField;
    const copyToSummary = this.state.fieldConfig.copyToSummary;
    const copyRequestType = this.state.fieldConfig.copyRequestType;
    const copyRequestTypeField = this.state.fieldConfig.copyRequestTypeField;
    const additionalTargetField = this.state.fieldConfig.additionalTargetField;
    const additionalTargetFieldValue = this.state.fieldConfig.additionalTargetFieldValue;
    const requestType = this.state.requestType;

    window.AP.context.getContext(function (response) {
      if (!response.jira.issue) {
        var requestProperties =
          new window.AP.jiraServiceDesk.RequestProperties();

        window.AP.events.on(
          "jira-servicedesk-request-properties-serialize",
          function () {
            let val = $(`#location`).val();
            let data = {
              field: targetField,
              value: val,
              copy: copyToSummary,
              requestType: requestType?.name,
            };

            if (additionalTargetField && additionalTargetFieldValue) {
              data["additionalField"] = additionalTargetFieldValue;
              data["additionalValue"] = $(`#additionalLocation`).val();
            }

            if (copyRequestType && copyRequestTypeField)
              data["copyRequestTypeField"] = copyRequestTypeField;

            requestProperties.serialize({
              com_company_twinitapp_location_issue_property: data,
            });
          },
        );

        window.AP.events.on("jira-servicedesk-request-created");
        window.AP.events.on(
          "jira-servicedesk-request-properties-validate",
          function () {
            var valid = true;

            if (!$(`#location`).val()) {
              if (isRequired) {
                if (!$(`#fieldErrorMessage`).length) {
                  $(`#location`)
                    .parent()
                    .append(
                      `<p id="fieldErrorMessage" class='field-error' style='font-size: 12px; color: rgb(191, 38, 0);'>Please provide a value for required field '${fieldName}'</p>`,
                    );
                }

                valid = false;
              }
            }

            requestProperties.validate(valid);
          },
        );
      }
    });
  }

  handleChange = (e) => {
    let val = "";
    if (e) {
      val = e.data;
      this.setState({ selectedData: e.data });
      this.searchIssues(val);
    } else {
      this.setState({ selectedData: "", issuesData: null });
    }
  };

  searchIssues = async (val) => {
    let newVal = val;

    if (this.state.dataSource.sourceType === "jira") {
      newVal = val;
    } else {
      newVal = interpolate(this.state.fieldConfig.valueExpression, {
        item: val,
      });
    }

    const fieldsVals = this.state.fields.map((n) => n);
    fieldsVals.push(this.state.fieldConfig.targetField);

    const key = this.state.fieldConfig.targetField.replace("customfield_", "");
    let filterField = key;
    if (this.state.fieldConfig.targetField.includes("customfield_")) {
      filterField = `cf[${key}]`;
    }

    const jql = this.state.jql ? ` AND (${this.state.jql})` : "";

    let searchVal = newVal.trim();
    const reservedJqlChars = [
      ";",
      "+",
      "-",
      "!",
      "(",
      ")",
      "{",
      "}",
      "[",
      "]",
      "^",
      "~",
    ];
    if (reservedJqlChars.some((char) => searchVal.endsWith(char))) {
      searchVal = searchVal.slice(0, -1);
    }

    var bodyData = `{
      "expand": "names",
      "jql": "${filterField} ~ '${searchVal}*' ${jql} ORDER BY created DESC",
      "maxResults": 15,
      "fieldsByKeys": false,
      "fields": []
    }`;
    console.log("bodyData before parsing: ", bodyData);

    const bodyDataJson = JSON.parse(bodyData);
    bodyDataJson["fields"] = fieldsVals;

    // bodyData = JSON.stringify(bodyDataJson);

    const response = await SearchIssues(this.state.token, bodyDataJson);
    this.setState({ issuesData: response?.issues });
  };

  handleDefaultParams = (data) => {
    this.setState({ defaultParams: data });
  };

  setValue(issueIdOrKey, value) {
    if (!value) return;

    var jsonValue = "";
    if (this.state.dataSource.sourceType === "jira") {
      jsonValue = value;
    } else {
      jsonValue = interpolate(this.state.fieldConfig.valueExpression, {
        item: value,
      });
    }

    const data = { fields: {} };
    data.fields[this.state.fieldConfig.targetField] = jsonValue;
    if (this.state.fieldConfig.copyToSummary) {
      data.fields["summary"] = jsonValue;
    }

    if (
      this.state.fieldConfig.additionalTargetField &&
      this.state.fieldConfig.additionalTargetFieldValue &&
      this.state.fieldConfig.additionalValueExpression
    ) {
      const additionalJsonValue = interpolate(
        this.state.fieldConfig.additionalValueExpression,
        { item: value }
      );
      data.fields[this.state.fieldConfig.additionalTargetFieldValue] = additionalJsonValue;
    }

    const jsonData = JSON.stringify(data);
    window.AP.request({
      url: `/rest/api/3/issue/${issueIdOrKey}`,
      type: "PUT",
      contentType: "application/json",
      data: jsonData,
      success: function (responseText) {
        window.AP.jira.refreshIssuePage();
      },
      error: function (xhr, statusText, errorThrown) {},
    });
  }

  render() {
    if (!this.state.dataSource || !this.state.fieldConfig)
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Spinner size={"medium"} />
        </div>
      );

    return (
      <div id={this.state.fieldConfig.name.replace(/ /g, "_")}>
        <div>
          <span style={{ color: "#6b778c", fontSize: 12, fontWeight: 600 }}>
            {this.state.fieldConfig.name}
            {this.state.fieldConfig.isRequired ? (
              <span style={{ color: "red" }}>*</span>
            ) : null}
          </span>
        </div>
        <div>
          <SearchSelect
            id={"srchSelect_" + this.state.fieldConfig.id}
            onDefaultParams={this.handleDefaultParams}
            onSelectionChange={this.handleChange}
            fieldConfiguration={this.state.fieldConfig}
            dataSource={this.state.dataSource}
            token={this.state.token}
            issueFieldsArray={this.state.issueFieldsArray}
          ></SearchSelect>
        </div>
        <div>
          <span style={{ color: "#6b778c", fontSize: 12 }}>
            {this.state.fieldConfig.description}
          </span>
        </div>
        <div>
          <SearchResult
            id={"srchResult_" + this.state.fieldConfig.id}
            resultExpression={
              this.state.fieldConfig.resultExpression
                ? this.state.fieldConfig.resultExpression.replace(" ", "")
                : this.state.fieldConfig.resultExpression
            }
            valueExpression={this.state.fieldConfig.valueExpression}
            additionalTargetField={this.state.fieldConfig.additionalTargetField}
            additionalValueExpression={this.state.fieldConfig.additionalValueExpression}
            data={this.state.selectedData}
            dataSource={this.state.dataSource}
            issueFieldsArray={this.state.issueFieldsArray}
          ></SearchResult>
          {this.state.issueInfoSheet &&
          this.state.fields &&
          this.state.fields.length > 0 ? (
            <PersonCasesResult
              id={"casesResult_" + this.state.fieldConfig.id}
              data={this.state.issuesData}
              fields={this.state.fields}
              usersType={this.state.fieldConfig.usersType}
              issueFieldsArray={this.state.issueFieldsArray}
            ></PersonCasesResult>
          ) : null}
        </div>
      </div>
    );
  }
}

export default SearchField;
